import { Route, Switch, Redirect } from 'wouter';
import { useAuth } from './contexts/AuthContext';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import Upload from './pages/Upload';
import Cards from './pages/Cards';
import Library from './pages/Library';
import Study from './pages/Study';
import Calendar from './pages/Calendar';
import Favorites from './pages/Favorites';
import Notes from './pages/Notes';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import TestPDF from './pages/TestPDF';

// 受保护的路由组件
function ProtectedRoute({ component: Component }: { component: React.ComponentType }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1a2e3e] flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#22a9d9] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-white/60">加载中...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  return <Component />;
}

function App() {
  // 检查是否已看过欢迎页
  const hasSeenWelcome = localStorage.getItem('hasSeenWelcome');

  return (
    <Switch>
      {/* 公开页面 */}
      <Route path="/welcome" component={Welcome} />
      <Route path="/login" component={Login} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/reset-password" component={ResetPassword} />

      {/* 受保护的页面 */}
      <Route path="/">
        {() => <ProtectedRoute component={Home} />}
      </Route>
      <Route path="/study">
        {() => <ProtectedRoute component={Study} />}
      </Route>
      <Route path="/upload">
        {() => <ProtectedRoute component={Upload} />}
      </Route>
      <Route path="/cards">
        {() => <ProtectedRoute component={Cards} />}
      </Route>
      <Route path="/library">
        {() => <ProtectedRoute component={Library} />}
      </Route>
      <Route path="/calendar">
        {() => <ProtectedRoute component={Calendar} />}
      </Route>
      <Route path="/favorites">
        {() => <ProtectedRoute component={Favorites} />}
      </Route>
      <Route path="/notes">
        {() => <ProtectedRoute component={Notes} />}
      </Route>
      <Route path="/notifications">
        {() => <ProtectedRoute component={Notifications} />}
      </Route>
      <Route path="/settings">
        {() => <ProtectedRoute component={Settings} />}
      </Route>
      <Route path="/test-pdf" component={TestPDF} />
      <Route path="/profile">
        {() => <ProtectedRoute component={Profile} />}
      </Route>



      {/* 404页面 */}
      <Route>
        {() => (
          <div className="min-h-screen bg-[#1a2e3e] flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-6xl font-bold text-gradient mb-4">404</h1>
              <p className="text-white/60 mb-8">页面不存在</p>
              <a
                href="/home"
                className="px-8 h-12 rounded-xl bg-gradient-to-r from-[#22a9d9] to-[#6c5ce7] text-white font-medium inline-flex items-center hover:shadow-glow transition-shadow"
              >
                返回首页
              </a>
            </div>
          </div>
        )}
      </Route>
    </Switch>
  );
}

export default App;
